/**
 * @name browser-names.constants
 * @description Core browser names constants in ngx-responsive
 *
 * @license MIT
 */
import { IBrowserNames } from '../interfaces';

export const BROWSER_NAMES: IBrowserNames = {
    CHROME: 'chrome',
    FIREFOX: 'firefox',
    IE:  'ie',
    SAFARI: 'safari',
    OPERA: 'opera',
    SILK: 'silk',
    YANDEX: 'yandex',
    NA: 'NA'
};
